export * from './lib/UiKitTypographyBase';
